// src/components/CustomDatePicker.js
import React from "react";
import { FormControl, FormLabel, FormHelperText } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";

const CustomDatePicker = ({ label, value, onChange, minDate, maxDate, name, error, helperText, infoText, required = true,disabled, noMarginTop = false,labelMarginBottom='' }) => {

  return (
    <FormControl fullWidth>
      <FormLabel
        className="form-label"
        htmlFor={name}
        sx={{
          color: "#1C252E",
          fontSize: {
            xs: "13px",
            sm: "13px",
            md: "14px",
            xl: "14px",
          },
          fontWeight: "500",
          lineHeight: "22px",
          mb: labelMarginBottom? labelMarginBottom : "0px",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div>
          {label} {required && <span className="asteriskColor"> *</span>}
        </div>
      </FormLabel>
      <DatePicker
        format="DD/MM/YYYY" 
        value={value ? dayjs(value) : null}
        onChange={(newValue) => {
          onChange({
            target: {
              name,
              value: newValue ? newValue.format("YYYY-MM-DD") : "",
            },
          });
        }}
        minDate={minDate ? dayjs(minDate) : null}
        maxDate={maxDate ? dayjs(maxDate) : null}
        slotProps={{
          textField: {
            fullWidth: true,
            variant: "outlined",
            error: error,
            InputProps: {
              readOnly: true, // ✅ Prevent typing
              onKeyDown: (e) => e.preventDefault(), // ✅ Block arrow & keyboard navigation
            },
            sx: {
              marginTop: noMarginTop ? "0" : "5px",
              "& .MuiOutlinedInput-root": {
                height: "44px",
                borderRadius: "8px",
                boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
                fontSize: "14px",
                backgroundColor: "inherit",
                ...(error && {
                  borderColor: "#d32f2f",
                  "& fieldset": {
                    borderColor: "#d32f2f",
                  },
                  "&:hover fieldset": {
                    borderColor: "#d32f2f",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#d32f2f",
                  },
                }),
              },
              "& .MuiInputBase-input": {
                height: "100%",
                fontSize: "14px",
              },
              "& .MuiInputBase-input::placeholder": {
                textTransform: "initial",
                fontSize: "14px",
                color: "#4F5E71",
                opacity: 1,
              },
            },
          },
        }}
         disabled={disabled} 
      />
      {error && helperText ? (
        <FormHelperText error sx={{ marginLeft: 0, marginTop: "4px", fontSize: "12px" }}>
          {helperText}
        </FormHelperText>
      ) : infoText ? (
        <FormHelperText sx={{ marginLeft: 0, marginTop: "4px", fontSize: "12px", color: "#6B7280" }}>
          {infoText}
        </FormHelperText>
      ) : null}
    </FormControl>
  );
};

export default CustomDatePicker;
